import axios from 'axios'

export const http = axios

export function authHttp() {
  return axios.create({
    headers: {
      Authorization: `Bearer ${localStorage.getItem('t')}`,
    },
  })
}
